import AppHostComponent, { logAppHostMetrics, logAppHostMetricsWithMsgDelay, } from '@office-start/app-host-component';
import { AppbarConnectorService } from '@office-start/appbar-connector-service';
import { useCurrentRoute, useOfficeComponentContext, } from '@office-start/component-context-service';
import { useStandaloneCopilotApp } from '@office-start/copilot-route-service';
import { useFeatureSettings } from '@office-start/feature-settings-service';
import { copilotM365AppId } from '@office-start/m365-apps-service';
import { CopilotAppPage, PageUnstyled, } from '@office-start/office-home-app-shared';
import { isMosRouteItem } from '@office-start/officehome-types';
import { getQueryParams } from '@office-start/url-parser-utility';
import { useUserEntitlements } from '@office-start/user-entitlements-service';
import React, { useMemo, useRef } from 'react';
export var appbarConnectorService = AppbarConnectorService.getInstance();
/**
 * For testing, at minimum update the contentUrl from the first staticTabs below
 */
export var AppHostPage = function () {
    var _a, _b;
    var currentRoute = useCurrentRoute();
    var featureSettings = (_a = useFeatureSettings().data) === null || _a === void 0 ? void 0 : _a.result;
    var copilotMode = (_b = featureSettings === null || featureSettings === void 0 ? void 0 : featureSettings.copilot) === null || _b === void 0 ? void 0 : _b.mode;
    // in mode B, render the new Copilot page for the Copilot MetaOS app
    var shouldUseNewCopilotAppPage = currentRoute &&
        isMosRouteItem(currentRoute) &&
        copilotMode === 'ModeB' &&
        (currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.appId) === copilotM365AppId;
    return shouldUseNewCopilotAppPage ? (React.createElement(CopilotAppPage, null)) : (React.createElement(AppHostPageModeA, null));
};
var AppHostPageModeA = function () {
    var currentRoute = useCurrentRoute();
    var loggedAppIdRef = useRef(null);
    var componentContext = useOfficeComponentContext().data;
    var isStandaloneCopilotApp = useStandaloneCopilotApp();
    var userEntitlements = useUserEntitlements().data;
    var additionalParams = useMemo(function () {
        return getQueryParams(location.search);
    }, []);
    if (!currentRoute ||
        !isMosRouteItem(currentRoute) ||
        !currentRoute.appId ||
        !componentContext) {
        return null;
    }
    if (currentRoute && currentRoute.appId !== loggedAppIdRef.current) {
        if (!appbarConnectorService.tileChanged) {
            var entries = performance.getEntriesByType('navigation');
            if (entries &&
                entries.length > 0 &&
                entries[0].responseEnd &&
                entries[0].responseEnd >= 0) {
                logAppHostMetricsWithMsgDelay(currentRoute.appId, 'PageFetchTimeFromServer', Math.round(entries[0].responseEnd), appbarConnectorService.tileChanged, window.location.pathname, entries[0].redirectCount, isStandaloneCopilotApp, window.location.search);
            }
        }
        else {
            logAppHostMetricsWithMsgDelay(currentRoute.appId, 'PageFetchTimeFromServer', 0, appbarConnectorService.tileChanged, window.location.pathname, undefined, isStandaloneCopilotApp, window.location.search);
        }
        logAppHostMetrics({
            appId: currentRoute.appId,
            scenarioName: 'AppHostPageStart',
            clientTimeStamp: appbarConnectorService === null || appbarConnectorService === void 0 ? void 0 : appbarConnectorService.userClickTime,
            tileChanged: appbarConnectorService === null || appbarConnectorService === void 0 ? void 0 : appbarConnectorService.tileChanged,
            appUrl: window.location.pathname,
            appSearchParams: window.location.search,
            isStandaloneApp: isStandaloneCopilotApp,
        });
        loggedAppIdRef.current = currentRoute.appId;
    }
    return (React.createElement(PageUnstyled, { errorEventName: "M365Apps", name: "M365Apps" },
        React.createElement(AppHostComponent, { additionalParams: additionalParams, appbarConnectorService: appbarConnectorService, appId: currentRoute.appId, entityId: currentRoute.entityId, key: "".concat(currentRoute.appId, "_").concat(currentRoute.entityId), subPageId: currentRoute.subPageId })));
};
//# sourceMappingURL=AppHostPage.js.map